export interface RdsTextItem {
  text: string;
}

export function instanceOfRdsTextItem(something: any): something is RdsTextItem {
  return !!something && !!something.text;
}
